export default "__VITE_ASSET__Db61yFnd__"